import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import UpdatePasswordRequest from '../../../Spirit/Admin/Interfaces/Models/AccountService/UpdatePasswordRequest';
import LoginRequest from '../../../Spirit/Admin/Interfaces/Models/AccountService/LoginRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import UserInfoResponse from '../../../Spirit/Admin/Interfaces/Models/AccountService/UserInfoResponse';

export default class AccountService {
	webApiService: WebApiService;
	GetUserInfoEvent = new Events<WsResponseModelT<UserInfoResponse>>();
	UpdatePasswordEvent = new Events<WsResponseModelT<Boolean>>();
	LoginEvent = new Events<WsResponseModelT<Boolean>>();
	LogoutEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('AccountService', 'GetUserInfo', (res: WsResponseModelT<UserInfoResponse>) => {
			self.GetUserInfoEvent.trigger(res);
		});
		webApiService.on('AccountService', 'UpdatePassword', (res: WsResponseModelT<Boolean>) => {
			self.UpdatePasswordEvent.trigger(res);
		});
		webApiService.on('AccountService', 'Login', (res: WsResponseModelT<Boolean>) => {
			self.LoginEvent.trigger(res);
		});
		webApiService.on('AccountService', 'Logout', (res: WsResponseModelT<Boolean>) => {
			self.LogoutEvent.trigger(res);
		});
	}
	GetUserInfo() { 	
        this.webApiService.send('AccountService', 'GetUserInfo' );
    }
	UpdatePassword(request: UpdatePasswordRequest = null) { 	
        this.webApiService.send('AccountService', 'UpdatePassword' , request);
    }
	Login(request: LoginRequest = null) { 	
        this.webApiService.send('AccountService', 'Login' , request);
    }
	Logout() { 	
        this.webApiService.send('AccountService', 'Logout' );
    }
	 // async methods
	async getUserInfoAsync(): Promise<UserInfoResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetUserInfo.bind(this), this.GetUserInfoEvent)();
	}
	async updatePasswordAsync(request: UpdatePasswordRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdatePassword.bind(this), this.UpdatePasswordEvent)(request);
	}
	async loginAsync(request: LoginRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Login.bind(this), this.LoginEvent)(request);
	}
	async logoutAsync(): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Logout.bind(this), this.LogoutEvent)();
	}
}